import request from '@/utils/request'

//const serverURL = "https://vab-unicloud-3a9da9.service.tcloudbase.com";
//const apiURL = "/notice/getList";

export function getPeoples(params) {
  return request({
    url: '/people/findList',
    method: 'get',
    params,
  })
}
export function getPeople(params) {
  return request({
    url: '/people/find',
    method: 'get',
    params,
  })
}
export function getAllLevels(params) {
  return request({
    url: '/people/findLevelAll',
    method: 'get',
    params,
  })
}

export function getLevels(params) {
  return request({
    url: '/people/findLevelList',
    method: 'get',
    params,
  })
}

export function addLevel(data) {
  return request({
    url: '/people/createLevel',
    method: 'post',
    data,
  })
}

export function editLevel(data) {
  return request({
    url: '/people/updateLevel',
    method: 'post',
    data,
  })
}

export function delLevel(data) {
  return request({
    url: '/people/removeLevel',
    method: 'post',
    data,
  })
}

export function getAllLevelIcons(params) {
  return request({
    url: '/people/findLevelIconAll',
    method: 'get',
    params,
  })
}

export function getLevelIcons(params) {
  return request({
    url: '/people/findLevelIconList',
    method: 'get',
    params,
  })
}

export function addLevelIcon(data) {
  return request({
    url: '/people/createLevelIcon',
    method: 'post',
    data,
  })
}

export function editLevelIcon(data) {
  return request({
    url: '/people/updateLevelIcon',
    method: 'post',
    data,
  })
}

export function delLevelIcon(data) {
  return request({
    url: '/people/removeLevelIcon',
    method: 'post',
    data,
  })
}

export function getProfiles(params) {
  return request({
    url: '/people/findProfileList',
    method: 'get',
    params,
  })
}

export function addProfile(data) {
  return request({
    url: '/people/createProfile',
    method: 'post',
    data,
  })
}

export function editProfile(data) {
  return request({
    url: '/people/updateProfile',
    method: 'post',
    data,
  })
}

export function delProfile(data) {
  return request({
    url: '/people/removeProfile',
    method: 'post',
    data,
  })
}

export function bindProfile(data) {
  return request({
    url: '/people/bindProfile',
    method: 'post',
    data,
  })
}

export function importProfile(data) {
  return request({
    url: '/people/importProfile',
    method: 'post',
    data,
  })
}
